<script setup lang="ts">
/* Types */
import { Component } from '@/types/api/api-v3/product'

type Props = {
  component: Component
}

const props = defineProps<Props>()

const isErrorImage = ref(false)

const imageUrl = computed(() => {
  if (!props.component?.image || isErrorImage.value) {
    return './no-image-category.webp'
  }

  return props.component.image
})
</script>

<template>
  <div class="component">
    <nuxt-img
      class="component__image"
      :src="imageUrl"
      :alt="component.name"
      @error="isErrorImage = true"
    />

    <h5 class="component__title">{{ component.name }}</h5>

    <p class="component__description">{{ component.description }}</p>
  </div>
</template>

<style lang="scss" scoped>
.component {
  min-width: 140px;
  max-width: 140px;
  height: 180px;
  padding: 10px;
  margin-right: 12px;
  cursor: pointer;
  background: $white;
  border-radius: 16px;
  box-shadow: 0 4px 13px rgba(50, 52, 72, 0.07);
  -webkit-transition: max-width 0.5s ease;
  transition: max-width 0.5s ease;

  &__image {
    width: 76px;
    height: 50px;
    margin-top: 4px;
  }

  &__title {
    width: 100%;
    margin-top: 8px;
    font-size: 12px;
    font-weight: 800;
    line-height: 11px;
    color: $text-dark-gray;
    white-space: pre-wrap;
  }
  &__description {
    display: -moz-box;
    display: -webkit-box;
    width: 100%;
    margin-block-end: 0;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    color: $dark-grey;

    // для разных браузеров ставим ограничение в 5 строк видимости описания
    text-overflow: ellipsis;
    white-space: pre-wrap;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    line-clamp: 5;
  }

  &:hover {
    max-width: 250px;
  }

  @include media('>=tablet', '<=desktop-mini') {
    &__title {
      font-size: 14px;
    }

    &__description {
      font-size: 12px;
    }
  }

  @include media('<desktop-mini') {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 0 10px;
    align-items: center;
    min-width: 100%;
    height: max-content;
    min-height: 105px;
    padding: 20px 10px;
    box-shadow: 0 6px 30px rgba(50, 52, 72, 0.1);

    &__image {
      grid-area: 1 / 1 / 3 / 2;
    }

    &__title {
      grid-area: 1 / 2 / 2 / 3;
      height: max-content;
      font-weight: 800;
      line-height: 16px;
    }

    &__description {
      grid-area: 2 / 2 / 3 / 3;
      font-weight: 500;
      line-height: 14px;
    }
  }
}
</style>
